import { VirtualRoomMeta } from '~/types/resources';

type LocationBase = Pick<Location, 'origin' | 'hostname'>;

const getInstanceBaseUrls = () => {
  const commaSeparatedBaseUrls =
    (import.meta.env.VITE_INSTANCE_BASE_URLS as string | undefined) ?? '';

  return commaSeparatedBaseUrls.split(',');
};

export const getIsVirtualRoom = ({ origin, hostname }: LocationBase = window.location) => {
  if (import.meta.env.VITE_AUTHORIZATION_PROVIDER_TYPE === 'dev_oidc') {
    return true;
  }

  const baseUrls = getInstanceBaseUrls();

  return !baseUrls.includes(origin) && hostname !== 'localhost';
};

export const getBaseUrl = () => {
  return window.location.origin;
};

export type EnhancedRealmMetadata = Omit<
  VirtualRoomMeta,
  'realm' | 'oidcServerDiscoveryURI' | 'instanceId' | 'clientId'
> & {
  isSSO: boolean;
  isLocalhost: boolean;

  realm: string | undefined;
  oidcServerDiscoveryURI: string | undefined;
  instanceId: string | undefined;
  clientId: string | undefined;
};

export const getRealmFallbackData = ({ origin, hostname }: LocationBase): EnhancedRealmMetadata => {
  const isLocalhost = hostname === 'localhost';

  return {
    isSSO: getIsVirtualRoom({ origin, hostname }),
    isLocalhost,
    clientId: import.meta.env.VITE_DEV_OIDC_CLIENT_ID ?? undefined,
    enableRefreshTokens: isLocalhost
      ? import.meta.env.VITE_DEV_OIDC_ALLOW_REFRESH_TOKENS_WITH_ROTATION === 'true'
      : true,
    realm: isLocalhost ? import.meta.env.VITE_DEV_OIDC_REALM : undefined,
    oidcServerDiscoveryURI: isLocalhost ? import.meta.env.VITE_DEV_OIDC_DISCOVERY_URI : undefined,
    instanceId: import.meta.env.VITE_DEV_OIDC_INSTANCE_ID ?? undefined,
  };
};
